(function(runtime) {

    var _ = runtime.components.dependencies._;
    var $ = runtime.components.dependencies.jQuery.v1_11;
    var Modernizr = runtime.components.dependencies.Modernizr;

    var constants = runtime.components.constants.merge({
       templates: {
           // HTML markup of popup, `mfp-close` will be replaced by the close button
           framelessIframe: ['<div class="mfp-iframe-scaler">',
                             '<div class="mfp-close"></div>',
                             '<div class="mfp-iframe-container">',
                             '<iframe name="ixp-c-lightbox-frame" class="mfp-iframe" frameEnabled="0" allowfullscreen></iframe>',
                             '</div>',
                             '</div>'].join(''),
           // HTML markup of popup, `mfp-close` will be replaced by the close button
           framedIframe: ['<div class="mfp-frame">',
                          '<div class="mfp-content-inner">',
                          '<div class="mfp-iframe-scaler">',
                          '<div class="mfp-close"></div>',
                          '<div class="mfp-iframe-container">',
                          '<iframe name="ixp-c-lightbox-frame" class="mfp-iframe" frameEnabled="0" allowfullscreen></iframe>',
                          '</div>',
                          '</div>',
                          '</div>',
                          '</div>'].join(''),
           framedImage: ['<div class="mfp-frame">',
                         '<div class="mfp-content-inner">',
                         '<div class="mfp-close"></div>',
                         '<div class="mfp-img"></div>',
                         '<div class="mfp-bottom-bar">',
                         '<div class="mfp-title"></div>',
                         '<div class="mfp-counter"></div>',
                         '</div>',
                         '</div>',
                         '</div>'].join('')
       },

       data: {
           openBehavior: 'data-ixp-behavior-lightbox-open',
           openBehaviorScope: 'data-ixp-behavior-scope-lightbox-open',
           openOnContainerBehavior: 'data-ixp-behavior-lightbox-open-on-container'
       },

       selectors: {
           openLightbox: '[data-ixp-behavior-lightbox-open]',
           openFromContainer: '[data-ixp-behavior-lightbox-open-on-container]',
           popup: '.ixp-component-lightbox-popup',
           wrap: '.mfp-wrap',
           frame: '.mfp-frame',
           close: '.mfp-close',
           bg: '.mfp-bg',
           ready: '.mfp-ready',
           content: '.mfp-content',
           iframeScaler: '.mfp-iframe-scaler',
           iframeContainer: '.mfp-iframe-scaler .mfp-iframe-container'
       },

       css: {
           classes: {
               componentWrap: 'ixp-component-lightbox-wrap',
               componentBackground: 'ixp-component-lightbox-bg',
               framed: 'ixp-component-lightbox-framed',
               noCloseButton: 'ixp-component-lightbox-no-close',
               withAnimation: 'mfp-with-anim',
               withImageZoom: 'mfp-with-zoom',
               isTrigger: 'ixp-component-lightbox-is-trigger',
               hideLightbox: 'ixp-dynamic-vis'
           }
       },

       animation: {
           fade: {
               duration: 200,
               cssClass: 'mfp-fade'
           },
           zoom: {
               duration: 200,
               cssClass: 'mfp-zoom-in'
           },
           zoomOut: {
               duration: 300,
               cssClass: 'mfp-zoom-out'
           },
           slideIn: {
               duration: 300,
               cssClass: 'mfp-move-horizontal'
           },
           slideInTop: {
               duration: 200,
               cssClass: 'mfp-move-from-top'
           },
           unfold: {
               duration: 500,
               cssClass: 'mfp-3d-unfold'
           }
       },

       extensibility: {
           commands: {
               open: ':open',
               close: ':close',
               toggle: ':toggle',
               status: ':status'
           },

           events: {
               opening: ':opening',
               opened: ':opened',
               closing: ':closing',
               closed: ':closed',
               status: ':status'
           }
       }
   });

    var statics = {
        getLightboxInstance: function() {
            return $.magnificPopup && $.magnificPopup.instance;
        },

        isOpen: function() {
            var instance = statics.getLightboxInstance();
            return !!(instance && instance.currItem);
        },

        toPixels: function(val) {
            return String(val).indexOf("px") > -1 ? val : val += "px";
        },

        getBehaviorsFromEl: function (el) {
            el = el instanceof $ ? el.get(0) : el;
            return Array.prototype
                .filter.call(el.attributes, function (attr) {
                    return attr.name.indexOf('data-ixp-behavior-lightbox') === 0
                })
                .map(function (attr) {
                    return attr.name
                })
        },

        isPdfUrl: function(url) {
            if (!url || typeof url !== 'string') {
                return false;
            }

            var normalizedUrl = url.split('#')[0].split('?')[0];
            return /\.pdf$/i.test(normalizedUrl);
        },

        getLightboxUrl: function(url) {
            if (!statics.isPdfUrl(url)) {
                return url;
            }

            return '/Global/UxPlugins/ixp-pdf-viewer/html/pdf-viewer.html?file=' + encodeURIComponent(url);
        }
    };

    runtime.components.registerExtensibility('ixp-lightbox-container', {
        commands: constants.extensibility.commands || {},
        events:   constants.extensibility.events || {}
    });

    return runtime.components.register('ixp-lightbox-container', {
        initialize: function(options) {
            if (this.contentType === "image" && this.contentImage) {
                (new Image()).src = this.contentImage;
            }

            this.isIOS = Modernizr.ios;

            // Opening a new tab must happen directly in a user gesture. Preserve the
            // existing lightbox for open-on-load configurations, which browsers would
            // otherwise treat as an unsolicited popup.
            this.openPdfInNewTab = !!(options && options.openPdfInNewTab) &&
                                   this.contentType === 'url' &&
                                   !this.openOnLoad;

            this.imageZoom = (this.animation === 'imageZoom');

            // note that image zoom overrides other animations
            this.hasAnimation = !this.imageZoom && this.animation !== 'none';
        },

        onGetCommandMap: function() {
            var commands = {};
            commands[constants.extensibility.commands.open] = {
                fn: this._onCommandOpen
            };
            commands[constants.extensibility.commands.close] = {
                fn: this._onCommandClose
            };
            commands[constants.extensibility.commands.toggle] = {
                fn: this._onCommandToggle
            };
            commands[constants.extensibility.commands.status] = {
                fn: this._onCommandStatus
            };
            return commands;
        },

        _onCommandOpen: function() {
            if (this.openPdfInNewTab) {
                this._openPdfInNewTab();
                return;
            }

            this.$trigger.magnificPopup('open');
        },

        _onCommandClose: function() {
            this.$trigger.magnificPopup('close');
        },

        _onCommandToggle: function() {
            var toggleMethod = statics.isOpen() ? 'open' : 'close';
            this.$trigger.magnificPopup(toggleMethod);
        },

        _onCommandStatus: function(options) {
            var isOpen = statics.isOpen();
            var ee = {
                contentType: this.contentType,
                isOpen: !!isOpen,
                isClosed: !isOpen
            };
            this.triggerExtensibility(constants.extensibility.events.status, ee, {done: options && options.done});
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            var attrs = {};
            var token = new Date().getTime() + "_lightbox";

            attrs[constants.data.openBehavior] = '';
            attrs[constants.data.openBehaviorScope] = token;

            var container = builder.scaffoldContainer('Lightbox');
            var link = builder.scaffoldLink('Lightbox Link');
            link.content.htmlAttributes = attrs;
            link.style.customClass = 'button button-a button-medium';
            container.content.scaffolding = [link];

            var rootAttrs = {};
            rootAttrs[constants.components.data.behaviorScopeOwner] = token;

            return {
                scaffolding: [container],
                content: {
                    htmlAttributes: rootAttrs
                },
                style: {
                    customClass: builder.getDefaultTheme('lightbox')
                }
            };
        },

        onDocumentReady: function() {
            if (this.inStudio) {
                if (!this.openOnLoad && this.openOnLoadHideTrigger === constants.css.classes.hideLightbox) {
                    this.$el.removeClass(constants.css.classes.hideLightbox);
                }

                return true;
            }

            var $innerBehaviors = this.$el.find(constants.selectors.openLightbox);
            var hasContainerBehavior = this.$el.is(constants.selectors.openFromContainer);

            this.$el.toggleClass(constants.css.classes.isTrigger, hasContainerBehavior || !$innerBehaviors.length);

            this.$lightboxDiv = this.$el.find('#Popup_' + this.instanceId);

            this._setConfig();
            this._setStyles();

            this.$lightboxDiv.toggleClass(constants.css.classes.withAnimation, this.hasAnimation);

            this.$trigger = (!hasContainerBehavior && $innerBehaviors.length) ? $innerBehaviors : this.$el;

            if (this.openPdfInNewTab) {
                this._configurePdfDirectOpen();
                return true;
            }

            this.$trigger.magnificPopup(this.config);

            $.magnificPopup.instance._setFocus = function() {
                $.magnificPopup.instance.contentContainer.focus();
            };

            if (this.openOnLoad && !ixp.runtime.isHiddenByCSS(this.$el)) {
                if (!this.openOnLoadDelay || this.openOnLoadDelay <= 0) {
                    this._onCommandOpen();
                } else {
                    var me = this;
                    setTimeout(function() {
                        me._onCommandOpen();
                    }, (this.openOnLoadDelay * 1000));
                }
            } else if (this.openOnLoadHideTrigger === constants.css.classes.hideLightbox) {
                this.$el.removeClass(constants.css.classes.hideLightbox);
            }

            return true;
        },

        _configurePdfDirectOpen: function() {
            var me = this;

            this.$trigger
                .attr('data-ixp-pdf-direct-open', '')
                .each(function() {
                    var $trigger = $(this);
                    if ($trigger.is('a')) {
                        $trigger.attr({
                            href: me.lightboxUrl,
                            target: '_blank',
                            rel: 'noopener'
                        });
                    } else {
                        $trigger.attr('role', 'link');
                        if (!$trigger.attr('tabindex')) {
                            $trigger.attr('tabindex', '0');
                        }
                    }
                })
                .on('click' + this.eventNamespace, function(e) {
                    e.preventDefault();
                    me._openPdfInNewTab();
                })
                .on('keydown' + this.eventNamespace, function(e) {
                    if (e.which !== 13 && e.which !== 32) {
                        return;
                    }

                    e.preventDefault();
                    me._openPdfInNewTab();
                });
        },

        _openPdfInNewTab: function() {
            var opened = window.open(this.lightboxUrl, '_blank');
            if (opened) {
                opened.opener = null;
            }

            _.defer(_.bind(this.pushInteraction, this, {
                name: 'lightbox pdf direct open'
            }));
        },

        _onBeforeOpen: function() {
            var mfpInstance = statics.getLightboxInstance();
            if (!mfpInstance) {
                return;
            }

            switch (this.contentType) {
                case 'image':
                    if (this.frameEnabled) {
                        mfpInstance.contentContainer.addClass(constants.css.classes.withAnimation);
                    } else {
                        mfpInstance.st.image.markup = mfpInstance.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                    }
                    break;

                case 'url':
                    mfpInstance.contentContainer.addClass(constants.css.classes.withAnimation);
                    break;

                default:
                    break;
            }

            if (this.flatBox) {
                mfpInstance.wrap.addClass('ixp-component-lightbox-flat');
            }
            mfpInstance.wrap.addClass(constants.css.classes.componentWrap);
            mfpInstance.bgOverlay.addClass(constants.css.classes.componentBackground);

            this.triggerExtensibility(constants.extensibility.events.opening);
        },

        _getIframeData: function() {
            var mfpInstance = statics.getLightboxInstance();
            if (!mfpInstance) {
                return;
            }

            var $iframe = mfpInstance.content.find('iframe.mfp-iframe').first();
            var childWindow = window.frames['ixp-c-lightbox-frame'];
            var childDoc = childWindow && childWindow.document;
            var $iframeBody = childDoc && $(childDoc.body);

            return {
                $el: $iframe,
                window: childWindow,
                document: childDoc,
                $body: $iframeBody
            }
        },
        _onOpen: function() {
            var mfpInstance = statics.getLightboxInstance();
            if (!mfpInstance) {
                return;
            }

            if (this.verticalAlign === "relative") {
                var offsetTop = this.$el.offset().top;

                var container = mfpInstance.contentContainer;
                var bounds = container[0].getBoundingClientRect();

                offsetTop = Math.max(40, offsetTop - (bounds.height / 2));
                container.offset({top: offsetTop});
            }
            if (this.contentType !== 'url') {
                this._tagClick();
            }

            this.triggerExtensibility(constants.extensibility.events.opened);

            if (this.contentType !== 'url') {
                return;
            }

            var me = this;

            if (this.isIOS) {

                setTimeout(function() {
                    var iframeData = me._getIframeData();
                    if (!iframeData) {
                        return;
                    }
                    var $iframe = iframeData.$el;
                    var $iframeBody = iframeData.$body;

                    var blurTimer;
                    $(iframeData.document).on('focus', 'input, textarea, select', function(e) {
                        if (blurTimer) {
                            clearTimeout(blurTimer);
                        }
                        var $fixedThing = $('.mfp-wrap').first();
                        var fixedThing = $fixedThing[0];

                        if (fixedThing.style.position !== 'absolute') {
                            //If using a non-px value, you will have to get clever, or just use 0 and live with the temporary jump.
                            var top = parseFloat(window.getComputedStyle(fixedThing).top) || 0;
                            if (isNaN(top)) {
                                top = 0;
                            }
                            //Switch to position absolute.
                            var scrollY = window.scrollY;
                            //console.log('scroll', scrollY, 'top', top);
                            fixedThing.style.top = (scrollY + top) + 'px';
                            fixedThing.style.position = 'absolute';
                            fixedThing.style.display = 'none';
                            _.defer(function() {
                                fixedThing.style.display = '';
                            });
                        }
                        var $input = $(e.currentTarget);
                        $input.one('blur', function() {
                            if (blurTimer) {
                                clearTimeout(blurTimer);
                            }
                            blurTimer = setTimeout(function() {
                                fixedThing.style.position = '';
                                fixedThing.style.top = '';
                                blurTimer = null;
                            }, 500);
                        });
                    });
                }, 500);
            }

            if (this.autoHeight) {
              var iframeData = this._getIframeData();
              if (!iframeData) {
                  return;
              }
              var $iframe = iframeData.$el;
              var $iframeBody = iframeData.$body;

                try {
                    $iframeBody.css('overflow-y', 'hidden');

                    $iframe.load(function() {
                        me._calcHeight($iframe);

                        var el = this;
                        $(el.contentWindow).resize(function(e) {
                            me._calcHeight($(el));
                        });
                    });
                }
                catch (ex) { }
            }

            _.defer(_.bind(this.pushInteraction, this, {
                name: 'lightbox open',
                behaviorName: mfpInstance.st && mfpInstance.st.el && statics.getBehaviorsFromEl(mfpInstance.st.el)[0]
            }));
        },

        _onBeforeClose: function() {
            this.triggerExtensibility(constants.extensibility.events.closing);
        },

        _onClosed: function() {
            this.triggerExtensibility(constants.extensibility.events.closed);
            _.defer(_.bind(this.pushInteraction, this, {
                name: 'lightbox close'
            }));
        },

        _setConfig: function() {
            this.config = {
                mainClass: this.instanceId,
                closeOnBgClick: this.overlayClickClose,
                showCloseBtn: this.closeBtnEnabled,
                closeOnContentClick: this.closeOnContentClick,
                fixedContentPos: this.fixedContentPos,
                callbacks: {
                    beforeOpen: _.bind(this._onBeforeOpen, this),
                    open: _.bind(this._onOpen, this),
                    beforeClose: _.bind(this._onBeforeClose, this),
                    afterClose: _.bind(this._onClosed, this)
                }
            };

            if (this.hasAnimation) {
                this.config.mainClass += ' ' + constants.animation[this.animation].cssClass;
                this.config.removalDelay = constants.animation[this.animation].duration;
            }

            switch (this.contentType) {
                case 'text':
                    _.extend(this.config, {
                        items: {
                            src: this.$lightboxDiv
                        },
                        type: 'inline'
                    });
                    break;

                case 'image':
                    _.extend(this.config, {
                        items: {
                            delegate: constants.selectors.openLightbox,
                            src: this.contentImage,
                            type: 'image'
                        }
                    });

                    if (this.imageZoom) {
                        this.config.mainClass += ' ' + constants.css.classes.withImageZoom;
                        this.config.zoom = {
                            enabled: true, // By default it's false, so don't forget to enable it
                            duration: 300, // duration of the effect, in milliseconds
                            easing: 'ease-in-out', // CSS transition easing function
                            // The "opener" function should return the element from which popup will be zoomed in
                            // and to which popup will be scaled down
                            opener: function(openerElement) {
                                var $opener = $.magnificPopup.instance.st.el;

                                if (!$opener.length) {
                                    $opener = $($.magnificPopup.instance.ev[0]);
                                }

                                return $opener.is('img') ? $opener : $opener.find('img');
                            }
                        };
                    }

                    if (this.frameEnabled === true) {
                        this.config.image = {
                            markup: constants.templates.framedImage
                        };
                    }
                    break;

                case 'url':
                    var lightboxUrl = statics.getLightboxUrl(this.lightboxUrl);

                    _.extend(this.config, {
                        type: 'iframe',
                        items: {
                            src: lightboxUrl
                        },

                        iframe: {
                            markup: (this.frameEnabled == true ? constants.templates.framedIframe : constants.templates.framelessIframe)
                        },
                        srcAction: 'iframe_src'
                    });
                    break;

                default:
                    throw new Error('Lightbox content type must be text, image or url');

            }

            this.config.alignTop = (this.verticalAlign === 'top' || this.verticalAlign === "relative");

            if (this.frameEnabled === true) {
                this.config.mainClass += ' ' + constants.css.classes.framed;
            }

            if (this.closeBtnEnabled !== true) {
                this.config.mainClass += ' ' + constants.css.classes.noCloseButton;
            }
        },

        disallowedChildrenTypes: function(context) {
            return ['ixp-lightbox-container'];
        },

        getParamMapOverrides: function() {
            return {
                openOnLoad: function(val) {
                    this.openOnLoad = val;
                    this.$el.toggleClass(constants.css.classes.hideLightbox, this.openOnLoadHideTrigger === constants.css.classes.hideLightbox && val);
                },
                openOnLoadHideTrigger: function(val) {
                    this.openOnLoadHideTrigger = val;
                    this.$el.toggleClass(constants.css.classes.hideLightbox, val === constants.css.classes.hideLightbox && this.openOnLoad);
                }
            };
        },

        _setStyles: function() {
            var width = parseInt(this.width, 10) || 900;
            var height = parseInt(this.height, 10);
            var opacityFloat = parseFloat(this.opacity);
            var opacityNum = opacityFloat * 100;

            var rules = [];

            var borderRule = {
                selector: constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.frame,
                declarations: []
            };

            var closeRule = {
                selector: constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.close,
                declarations: []
            };

            var overlayRule = {
                selector: ".mfp-bg." + this.instanceId,
                declarations: [
                    {property: "opacity", value: opacityFloat},
                    {property: "filter", value: "alpha(opacity=" + opacityNum + ")"}
                ]
            };

            if (this.hasAnimation) {
                overlayRule.selector += constants.selectors.ready;
            }

            if (this.overlayColor && this.overlayColor !== "") {
                overlayRule.declarations.push({property: "background-color", value: this.overlayColor});
            }

            rules.push(overlayRule);

            if (this.contentType !== "image") {
                rules.push({
                               selector: constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.content,
                               declarations: [
                                   {property: "max-width", value: statics.toPixels(width)}
                               ]
                           });
            }

            if (this.closeColor && this.closeColor !== "") {
                closeRule.declarations.push({
                                                property: "color",
                                                value: this.closeColor
                                            });
            }

            // TODO: [ECA] Why was this code here?
            //if (this.frameEnabled === true) {
            //    var closeBarOffset = 22;
            //    var frameTopHeight = parseInt(this.frameThickness, 10) || 10;
            //    var borderWidth = frameTopHeight;
            //    if (frameTopHeight < closeBarOffset) {
            //        frameTopHeight = closeBarOffset + 2;
            //    }
            //    var closeHeight = statics.toPixels((frameTopHeight - 2));
            //    var strFrameTopHeight = statics.toPixels(frameTopHeight);
            //    var strBorderWidth = statics.toPixels(borderWidth);
            //}

            if (this.contentType === "url") {
                var aspectRatio = height / width;
                var percentHeight = aspectRatio * 100;
                rules.push({
                               selector: constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.iframeScaler,
                               declarations: [
                                   {property: "padding-top", value: String(percentHeight) + "%"}
                               ]
                           });

                var frameContainerRule = {
                    selector: constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.iframeContainer, // iframe
                    declarations: []
                };

                if (this.frameColor && this.frameColor !== "") {
                    frameContainerRule.declarations.push({property: "background", value: this.frameColor});
                }

                if (this.isIOS === true) {
                    frameContainerRule.declarations.push(
                        {property: "overflow", value: "auto"},
                        {property: "-webkit-overflow-scrolling", value: "touch"}
                    );
                }

                if (frameContainerRule.declarations.length > 0) {
                    rules.push(frameContainerRule);
                }
            } else if (this.contentType === "text") {
                borderRule.selector = constants.selectors.wrap + '.' + this.instanceId + ' ' + constants.selectors.popup;
            }

            if (this.frameEnabled === true && this.frameRadius && this.frameRadius !== "") {
                var strFrameRadius = statics.toPixels(this.frameRadius);
                borderRule.declarations.push(
                    {property: "-moz-border-radius", value: strFrameRadius},
                    {property: "-webkit-border-radius", value: strFrameRadius},
                    {property: "border-radius", value: strFrameRadius}
                );
            }

            if ((this.frameEnabled === true || this.contentType === "text") && (this.frameColor && this.frameColor !== "")) {
                borderRule.declarations.push({
                                                 property: "background",
                                                 value: this.frameColor
                                             });
            }

            if (borderRule && borderRule.declarations.length > 0) {
                rules.push(borderRule);
            }

            if (closeRule && closeRule.declarations.length > 0) {
                rules.push(closeRule);
            }

            this.addOrUpdateStyleBlock(rules);
        },

        _tagClick: function() {
            if (this.tagValue != "" && window.liveballTag) {
                liveballTag(this.tagValue);
            }
        },

        _calcHeight: function($iframe) {
            var $iframeBody = $($iframe[0].contentWindow.document.body);

            $iframeBody.css('overflow-y', 'hidden');

            var iframeHeight = $iframeBody.height();
            $iframe.css('height', iframeHeight);
            if (this.frameEnabled) {
                $iframe.closest('.mfp-frame').css('height', iframeHeight);
            } else {
                $iframe.closest('.mfp-content').css('height', iframeHeight);
            }
            $iframe.closest('.mfp-content-inner').css('height', 'inherit');
        }
    });

})(window.ixp.runtime);
